// extracted by mini-css-extract-plugin
module.exports = {"branchList":"style-module_branchList__1_r_hTVNlEYcUJRng33k5l","branchListItems":"style-module_branchListItems__3wNlgKnipz1Rpk1AL69oQs"};